import { create } from "zustand";

const useSidebarTrigger = create((set) => ({
  sidebarCollapse: false,
  setSidebarCollapse: (value) => set({ sidebarCollapse: value }),
}));

export default useSidebarTrigger;
